import * as React from 'react';
export const IntersectionObserverContext = React.createContext(null);
/** Intersection Observer 컨텍스트를 읽는다. Provider 밖이면 예외를 던진다. */
export function useIntersectionObserverContext() {
    const context = React.useContext(IntersectionObserverContext);
    if (!context) {
        throw new Error('Intersection Observer 훅은 IntersectionObserverProvider 내부에서 사용해야 합니다.');
    }
    return context;
}
//# sourceMappingURL=context.js.map